import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class NotificationSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success =
      serverRes.statusCode == 200 ||
      serverRes.statusCode == 201 ||
      serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: NOTIFICATION_ERR_${serverRes.statusCode || raw.status || '1000'}`,
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Notifications got',
      data: (Array.isArray(serverRes?.data?.appInfo?.notifications)
        ? serverRes?.data?.appInfo?.notifications
        : []
      ).map((notification) => {
        return {
          id: notification.id,
          title: notification.title,
          description: notification.description,
          country: notification.country || 'ANY'
        };
      })
    };
  }

  serialize(newNotification, allNotifications) {
    let res = [...allNotifications];
    let updated = false;
    res.forEach((el, i) => {
      if (el.id !== newNotification.id) return;
      updated = true;
      res[i] = newNotification;
    });
    if (!updated) res.push(newNotification);
    res = res.filter((el) => el.action !== 'delete');
    return {
      appInfo: {
        notifications: res
      }
    };
  }
}

export const serializer = new NotificationSerializer();
